import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { AppHeader } from "@/components/AppHeader";
import { Toaster } from "sonner";
import { usePage, Link } from "@inertiajs/react";
import { Settings } from "lucide-react";
import { AlertBanner } from "@/components/ui/alert-banner";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { props, url } = usePage();
  const lineSettingRequired = props.lineSettingRequired as boolean;

  // /users/settings ページではアラートを非表示
  const isSettingsPage = url === '/users/settings';

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar />
        <div className="flex flex-1 flex-col">
          <AppHeader />
          <main className="flex-1 bg-background p-6">
            {/* LINE設定未完了アラート（設定ページ以外で表示） */}
            {lineSettingRequired && !isSettingsPage && (
              <div className="mb-6">
                <AlertBanner
                  variant="error"
                  title="LINE Messaging API の設定が必要です"
                  action={
                    <Link
                      href="/users/settings"
                      className="inline-flex items-center gap-2 rounded-md bg-red-50 px-3 py-2 text-sm font-medium text-red-800 hover:bg-red-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 dark:bg-transparent dark:text-red-200 dark:hover:bg-white/10 dark:focus-visible:outline-offset-1 dark:focus-visible:outline-red-500/50"
                    >
                      <Settings className="h-4 w-4" />
                      設定ページへ移動
                    </Link>
                  }
                >
                  <p>
                    友達追加URLや配信機能を利用するには、LINE Messaging API の設定を完了してください。
                  </p>
                </AlertBanner>
              </div>
            )}

            {children}
          </main>
        </div>
      </div>
      <Toaster position="top-right" richColors closeButton />
    </SidebarProvider>
  );
}
